<template>
  <nav>
    <VTabsV2
      :tabs="tabs"
      base-url="/flow/orders-v2"
      @update="onTabUpdate"
    />

    <OrdersPageFilterComponent
      v-if="activeTab?.id === 'not-shipped' || activeTab?.id === 'not-paid'"
      :filters="filter"
      @orders-page-filter:updated="onFilterUpdated"
    />
  </nav>

  <!-- Заказы, где хотя бы одна позиция отгружена не полностью -->
  <OrdersRegistryV2
    v-if="activeTab?.id === 'not-shipped'"
    :params="notShippedParams"
    :filter="filter"
  />

  <!-- Заказы, где по позиции осталась сумма без заявки на оплату -->
  <OrdersRegistryV2
    v-if="activeTab?.id === 'not-paid'"
    :params="notPaidParams"
    :filter="filter"
  />

  <!-- Сборки, отгруженные не полностью — как «Готовы к отгрузке» в OrdersPage -->
  <AssembliesRegistryExpanded
    v-if="activeTab?.id === 'assemblies'"
    :params="assembliesParams"
  />

  <PaymentRequestsRegistry v-if="activeTab?.id === 'payments'" />
</template>

<script lang="ts">
import AssembliesRegistryExpanded from '@/domains/Assemblies/components/AssembliesRegistryExpanded/AssembliesRegistryExpanded';
import PaymentRequestsRegistry    from '@/domains/PaymentRequests/components/PaymentRequestsRegistry/PaymentRequestsRegistry.vue';
import OrdersRegistryV2           from './OrdersRegistryV2.vue';
import TabElement                 from '@/lib/components/VTabsV2/TabElement';
import OrdersPageFilter           from '@/domains/Orders/components/OrdersPage/OrdersPageFilter/OrdersPageFilter';
import OrdersPageFilterComponent  from '@/domains/Orders/components/OrdersPage/OrdersPageFilter/OrdersPageFilterComponent.vue';
import Core                       from '@/core/Core';

/**
 * Фильтр «Заказов» со своим ключом в localStorage: залоченные поля не сохраняются,
 * и с общим ключом сохранение отсюда стирало бы их в фильтре страницы «Заказы»
 */
class OrdersPageV2Filter extends OrdersPageFilter {
  protected storageKey = 'filters:orders-v2';
}

/** Страница «Заказы 2» */
export default defineComponent({
  name: 'OrdersPageV2',

  components: {
    OrdersRegistryV2,
    OrdersPageFilterComponent,
    AssembliesRegistryExpanded,
    PaymentRequestsRegistry,
  },

  setup() {
    return {
      tabs: [
        TabElement.from('not-shipped', 'Не отгруженные'),
        TabElement.from('not-paid',    'Не оплаченные'),
        TabElement.from('assemblies',  'Сборочные листы'),
        TabElement.from('payments',    'Платежи'),
      ],
      notShippedParams: { isShippedEntirely: false },
      notPaidParams:    { woPaymentRequests: true },
      assembliesParams: { isShippedEntirely: false },
    };
  },

  data() {
    return {
      /** Активную вкладку сообщает VTabsV2 из роута */
      activeTab: null as TabElement | null,

      /** Меняются только ответственный и поставщик (синхронен с колонкой «Грузоотправитель»), остальное зафиксировано пресетом */
      filter: OrdersPageV2Filter.fromLocalStorage().applyPreset({
        deliveryType:   undefined,
        orderCategory:  undefined,
        isOfferBased:   Core.dictionaries.orderIsOfferBased.find(item => item.value === false),
        isSamples:      Core.dictionaries.orderIsSamples.get(OrdersPageFilter.DEFAULT_IS_SAMPLES_ID),
        isForTestsOnly: Core.dictionaries.orderIsForTestsOnly.get(OrdersPageFilter.DEFAULT_IS_FOR_TESTS_ONLY_ID),
        deliveryStatus: Core.dictionaries.orderDeliveryStatus.get(OrdersPageFilter.DEFAULT_DELIVERY_STATUS_ID),
        paymentStatus:  Core.dictionaries.orderPaymentStatus.get(OrdersPageFilter.DEFAULT_PAYMENT_STATUS_ID),
      }) as OrdersPageFilter,
    };
  },

  methods: {
    onTabUpdate(tab: TabElement | null) {
      this.activeTab = tab;
    },

    onFilterUpdated(newFilter: OrdersPageFilter) {
      this.filter = newFilter;
    },
  },
});
</script>
